export default "__VITE_ASSET__Detf_$4A__"